import { render, staticRenderFns } from "./visitors-milestone-overview.view.vue?vue&type=template&id=88b641aa&scoped=true&"
import script from "./visitors-milestone-overview.view.vue?vue&type=script&lang=ts&"
export * from "./visitors-milestone-overview.view.vue?vue&type=script&lang=ts&"
import style0 from "./visitors-milestone-overview.view.vue?vue&type=style&index=0&id=88b641aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b641aa",
  null
  
)

export default component.exports